<template>
  <div>
    <section class="w-full rounded shadow bg-bgr p-4 pb-16">
      <WebccHeading :level="3">{{ $t(`${trPrefix}noResults`) }}</WebccHeading>
      <span>{{ $t(`${trPrefix}modifyFilters`) }}</span>
      <FilterTags />
      <WebccButton @click="reset">{{
        $t(`${trPrefix}removeAllFilters`)
      }}</WebccButton>
    </section>

    <section
      v-for="{ key, destination, request, result } in alternatives"
      :key="key"
      class="mt-8"
    >
      <h3
        v-track:impression="{
          'search:zeroResultsBannerDisplayed': [],
          'search:results': [destination, request, result.docs.length],
          'ecommerce:viewItemList': [result.docs, destination],
        }"
        class="mb-6 px-4 py-3.5 border-2 border-bgr-300 rounded-lg text-xl font-semibold"
      >
        {{ $t(`${trPrefix}noResultsRecommender.${key}`) }}
      </h3>
      <div class="hidden md:grid gap-4 justify-start">
        <HitboxOrig
          v-for="accom in result.docs"
          :key="`${accom.code}_orig`"
          :accom
        />
      </div>
      <div class="md:hidden gap-4 sm:grid sm:grid-cols-2">
        <HitboxCard
          v-for="accom in result.docs"
          :key="`${accom.code}_card`"
          :accom
        />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.views.search.area.'

const search = useSearch()

const { data: alternatives } = useSearchAlternativesQuery(() => search.filters)

function reset() {
  search.setFilter({}, { reset: true })
}
</script>
